import { render, staticRenderFns } from "./ferti.vue?vue&type=template&id=306d4968&scoped=true&"
import script from "./ferti.vue?vue&type=script&lang=js&"
export * from "./ferti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306d4968",
  null
  
)

export default component.exports